import Button from 'components/UI/Button'
import { ReactElement, useState } from 'react'
import { useAppDispatch } from 'redux/hooks'
import { sendMessage } from 'redux/slices/message'
import { Page, pageActions } from 'redux/slices/page'
import { Flex, Text, Textarea } from 'theme-ui'
import { maxMessageLength } from 'utils/sizes'

export default function DescribeYourIssue(): ReactElement {
  const [message, setMessage] = useState('')
  const dispatch = useAppDispatch()
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Flex
        sx={{
          height: '71px',
          justifyContent: 'center',
          mb: '40px',
        }}
      >
        <Text
          sx={{
            fontSize: '28px',
            textAlign: 'center',
            wordBreak: 'break-word',
            maxWidth: '256px',
            fontWeight: 'bold',
          }}
          color="white"
        >
          Briefly describe your issue.
        </Text>
      </Flex>
      <Flex sx={{ mx: ['24px', '16px', '16px'], flexDirection: 'column', alignItems: 'flex-end' }}>
        <Textarea
          sx={{
            backgroundColor: 'white10',
            borderRadius: '1.6rem',
            color: 'white',
            border: 'none',
            p: '16px',
            resize: 'none',
            overflow: 'scroll',
            // hides scroll bar for IE, Edge, and Firefox
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            fontFamily: 'IBM PLEX SANS',
            fontSize: '16px',
          }}
          rows={5}
          placeholder="Type your message"
          onChange={({ target }) => setMessage(target.value)}
          data-testid="pre-chat-message-input"
          maxLength={maxMessageLength}
        />
        <Text
          color="white50"
          sx={{ mt: '8px', mr: '24px', fontSize: '12px' }}
          data-testid="char-count"
        >
          {message.length <= 20
            ? `${message.length}/20 minimum`
            : `${message.length}/${maxMessageLength} maximum`}
        </Text>
      </Flex>
      <Flex sx={{ justifyContent: 'center', mt: '39px' }}>
        <Button
          sx={{ minWidth: '198px' }}
          variant="neon"
          onClick={() => {
            dispatch(pageActions.switchPage(Page.CHAT_PAGE))
            dispatch(sendMessage(message))
          }}
          disabled={message.length < 20}
          data-testid="start-chat-button"
        >
          <Text sx={{ color: 'black', fontWeight: 'bold', fontSize: '18px' }}>Start chat</Text>
        </Button>
      </Flex>
    </Flex>
  )
}
